/**
 * The Step 1 "What happens next?" side rail. Static explanatory copy mirroring
 * the wizard's five phases, matching the approved mockup. Presentational only.
 */

const STEPS: readonly { title: string; detail: string }[] = [
  {
    title: "We'll fetch the schedule",
    detail: 'Read the source and pull in games, times, fields, and teams.',
  },
  {
    title: 'Match to your players',
    detail: 'Match event teams to your starred players.',
  },
  {
    title: 'Build your itinerary',
    detail: 'Games that include your starred players.',
  },
  {
    title: 'Assign to staff',
    detail: 'Assign games to your coaches.',
  },
];

export function WhatHappensNextRail() {
  return (
    <aside className="wiz-card wiz-rail" aria-label="What happens next">
      <h3 className="wiz-rail__title">What happens next?</h3>
      {STEPS.map((step, index) => (
        <div className="wiz-rail__item" key={step.title}>
          <span className="wiz-rail__num" aria-hidden="true">
            {index + 1}
          </span>
          <div>
            <b>{step.title}</b>
            <p className="wiz-rail__detail">{step.detail}</p>
          </div>
        </div>
      ))}
    </aside>
  );
}
